import React from 'react'

import { useTranslation } from 'react-i18next'

import { SectionText } from '../../../../../components/SectionText'

interface AnesthesiaProps {
    className?: string
}

export const Anesthesia: React.FC<AnesthesiaProps> = ({ className }) => {
    const { t } = useTranslation()
    return (
        <div className={`${className} bg-primary-blue-faded min-h-[500px] h-auto flex items-center justify-center`}>
            <div
                className="w-1/2 h-full text-white flex flex-col items-center justify-center
                sm:w-full sm:py-5 sm:px-5
              ">
                <SectionText
                    className="max-h-full flex flex-col justify-between"
                    title={t('AmbulantOperation.Anesthesia.anesthesia_title')}
                    hrLineColor="bg-primary-green">
                    <ul className="list-disc pl-5 flex flex-col min-h-[250px] py-3">
                        <li>{t('AmbulantOperation.Anesthesia.anesthesia_content_1')}</li>
                        <li className="pt-4">{t('AmbulantOperation.Anesthesia.anesthesia_content_2')}</li>
                    </ul>
                </SectionText>
            </div>
        </div>
    )
}
